import { LOGOUT_USER } from "../types/authTypes";
import { 
  FETCH_POT_ROUNDS, FETCH_POT_ROUNDS_SUCCESS, FETCH_POT_ROUNDS_FAILURE,
  FETCH_POT_ENTRIES, FETCH_POT_ENTRIES_SUCCESS, FETCH_POT_ENTRIES_FAILURE,
  COMPLETE_POT_ENTRY, COMPLETE_POT_ENTRY_SUCCESS, COMPLETE_POT_ENTRY_FAILURE,  
  SET_CURRENT_POT,
  CREATE_POT_ENTRY, CREATE_POT_ENTRY_SUCCESS, CREATE_POT_ENTRY_FAILURE,
  FETCH_POT_LEADERBOARDS, FETCH_POT_LEADERBOARDS_SUCCESS, FETCH_POT_LEADERBOARDS_FAILURE,
  FETCH_COMPLETED_POT_ROUNDS, FETCH_COMPLETED_POT_ROUNDS_SUCCESS, FETCH_COMPLETED_POT_ROUNDS_FAILURE,
  FETCH_ACTIVE_ROUND, FETCH_ACTIVE_ROUND_SUCCESS, FETCH_ACTIVE_ROUND_FAILURE,
  FETCH_NEXT_ROUND, FETCH_NEXT_ROUND_SUCCESS, FETCH_NEXT_ROUND_FAILURE
} from "../types/potsTypes";

const INITIAL_STATE = {
  potRounds: [],
  potEntries: [],
  leaderboards: [],
  completedPotRounds: [],
  activeRound: null,
  nextRound: null,
  privatePot: null,
  leaderboardMeta: {
    isFinalized: false,
    potName: '',
    roundName: ''
  },
  currentPot: null,
  pagination: {
    rounds: {},
    entries: {},
    credits: {},
    leaderboards: {}
  },
  loading: {
    rounds: false,
    entries: false,
    completingEntry: false,
    creatingEntry: false,
    privatePot: false,
    credits: false,
    usingCredit: false,
    leaderboards: false,
    completedRounds: false,
    activeRound: false,
    nextRound: false
  },
  errors: {
    rounds: null,
    entries: null,
    completingEntry: null,
    creatingEntry: null,
    privatePot: null,
    credits: null,
    usingCredit: null,
    leaderboards: null,
    completedRounds: null,
    activeRound: null,
    nextRound: null
  },
  success: {
    completedEntry: false,
    createdEntry: false,
    usedCredit: false
  }
};

const potsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Pot Rounds
    case FETCH_POT_ROUNDS:
      return {
        ...state,
        loading: { ...state.loading, rounds: true },
        errors: { ...state.errors, rounds: null }
      };
    
    case FETCH_POT_ROUNDS_SUCCESS:
      return {
        ...state,
        potRounds: action.payload,
        pagination: { 
          ...state.pagination, 
          rounds: action.pagination || {} 
        },
        loading: { ...state.loading, rounds: false },
      };
    
    case FETCH_POT_ROUNDS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, rounds: false },
        errors: { ...state.errors, rounds: action.payload }
      };

    // Pot Entries
    case FETCH_POT_ENTRIES:
      return {
        ...state,
        loading: { ...state.loading, entries: true },
        errors: { ...state.errors, entries: null }
      };
    
    case FETCH_POT_ENTRIES_SUCCESS:
      return {
        ...state,
        potEntries: action.payload,
        pagination: { 
          ...state.pagination, 
          entries: action.pagination || {} 
        },
        loading: { ...state.loading, entries: false },
      };
    
    case FETCH_POT_ENTRIES_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, entries: false },
        errors: { ...state.errors, entries: action.payload }
      };

    // Complete Pot Entry
    case COMPLETE_POT_ENTRY:
      return {
        ...state,
        loading: { ...state.loading, completingEntry: true },
        errors: { ...state.errors, completingEntry: null },
        success: { ...state.success, completedEntry: false }
      };
    
    case COMPLETE_POT_ENTRY_SUCCESS:
      return {
        ...state,
        potEntries: state.potEntries.map(entry => 
          entry.id === action.payload.id ? action.payload : entry
        ),
        loading: { ...state.loading, completingEntry: false },
        success: { ...state.success, completedEntry: true }
      };
    
    case COMPLETE_POT_ENTRY_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, completingEntry: false },
        errors: { ...state.errors, completingEntry: action.payload },
        success: { ...state.success, completedEntry: false }
      };    

    // Create Pot Entry
    case CREATE_POT_ENTRY:
      return {
        ...state,
        loading: { ...state.loading, creatingEntry: true },
        errors: { ...state.errors, creatingEntry: null },
        success: { ...state.success, createdEntry: false }
      };
    
    case CREATE_POT_ENTRY_SUCCESS:
      return {
        ...state,
        potEntries: [action.payload, ...state.potEntries],
        loading: { ...state.loading, creatingEntry: false },
        success: { ...state.success, createdEntry: true }
      };
    
    case CREATE_POT_ENTRY_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, creatingEntry: false },
        errors: { ...state.errors, creatingEntry: action.payload },
        success: { ...state.success, createdEntry: false }
      };

    // Set Current Pot
    case SET_CURRENT_POT:
      return {
        ...state,
        currentPot: action.payload
      };

    // Fetch Pot Leaderboards
    case FETCH_POT_LEADERBOARDS:
      return {
        ...state,
        loading: { ...state.loading, leaderboards: true },
        errors: { ...state.errors, leaderboards: null }
      };
    
    case FETCH_POT_LEADERBOARDS_SUCCESS:
      return {
        ...state,
        leaderboards: action.payload,
        leaderboardMeta: action.meta || {
          isFinalized: false,
          potName: '',
          roundName: '',
          fixtureCount: 0,
          potSize: 0,
        },
        pagination: { 
          ...state.pagination, 
          leaderboards: action.pagination || {} 
        },
        loading: { ...state.loading, leaderboards: false },
      };
    
    case FETCH_POT_LEADERBOARDS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, leaderboards: false },
        errors: { ...state.errors, leaderboards: action.payload }
      };

    // Fetch Completed Pot Rounds
    case FETCH_COMPLETED_POT_ROUNDS:
      return {
        ...state,
        loading: { ...state.loading, completedRounds: true },
        errors: { ...state.errors, completedRounds: null }
      };
    
    case FETCH_COMPLETED_POT_ROUNDS_SUCCESS:
      return {
        ...state,
        completedPotRounds: action.payload,
        loading: { ...state.loading, completedRounds: false },
      };
    
    case FETCH_COMPLETED_POT_ROUNDS_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, completedRounds: false },
        errors: { ...state.errors, completedRounds: action.payload }
      };

    // Fetch Active Round
    case FETCH_ACTIVE_ROUND:
      return {
        ...state,
        loading: { ...state.loading, activeRound: true },
        errors: { ...state.errors, activeRound: null }
      };
    
    case FETCH_ACTIVE_ROUND_SUCCESS:
      return {
        ...state,
        activeRound: action.payload,
        loading: { ...state.loading, activeRound: false },
      };
    
    case FETCH_ACTIVE_ROUND_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, activeRound: false },
        errors: { ...state.errors, activeRound: action.payload }
      };

    // Fetch Next Round
    case FETCH_NEXT_ROUND:
      return {
        ...state,
        loading: { ...state.loading, nextRound: true },
        errors: { ...state.errors, nextRound: null }
      };
    
    case FETCH_NEXT_ROUND_SUCCESS:
      return {
        ...state,
        nextRound: action.payload,
        loading: { ...state.loading, nextRound: false },
      };
    
    case FETCH_NEXT_ROUND_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, nextRound: false },
        errors: { ...state.errors, nextRound: action.payload }
      };

    // Fetch Private Pot by Passkey
    case 'FETCH_PRIVATE_POT_START':
      return {
        ...state,
        loading: { ...state.loading, privatePot: true },
        errors: { ...state.errors, privatePot: null },
        privatePot: null
      };
    
    case 'FETCH_PRIVATE_POT_SUCCESS':
      return {
        ...state,
        privatePot: action.payload,
        loading: { ...state.loading, privatePot: false },
        errors: { ...state.errors, privatePot: null }
      };
    
    case 'FETCH_PRIVATE_POT_FAILURE':
      return {
        ...state,
        loading: { ...state.loading, privatePot: false },
        errors: { ...state.errors, privatePot: action.payload },
        privatePot: null
      };

    case LOGOUT_USER:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default potsReducer;